var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityPageHeroShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 165,
    viewBox: "0 0 1440 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 164.193H1440V32.6559L1333.58 12.494C1203.17 -12.2134 1068.45 0.014595 944.619 47.7985C900.424 64.8526 854.638 77.4546 807.941 85.4173L684.886 106.4C632.772 115.287 579.838 118.406 527.042 115.703L384.724 108.416C323.492 105.28 262.11 109.979 202.069 122.398L0 164.193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityPageHeroShape);
export default __webpack_public_path__ + "static/media/community-page-hero-shape.54327be9da5c06f625c0cb23c7be1de2.svg";
export { ForwardRef as ReactComponent };